export default __webpack_public_path__ + "static/media/BG-Green-0002.5e8d1156.png";